import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';

import { AbntPipe } from '../../../../../shared/pipes/abnt.pipe';
import { AlertCardComponent } from '../../../../../shared/components/alert-card/alert-card.component';
import { AlertService, AlertType } from '../../../../../shared/services/alert.service';
import { ConciliacaoBancariaService } from '../../../../../shared/services/apis/financas/conciliacao-bancaria.service';
import { DesconciliarRequest } from '../../../../../shared/services/requests/financas/desconciliar.request';
import { ExtratoBancarioConciliadoItem } from '../../../../../shared/services/responses/financas/get-lancamentos-conciliados.response';

export enum TipoDesconciliacaoEnum {
  Simples  = 1,
  Completo = 2,
}

export interface DesconciliarDialogData {
  extrato: ExtratoBancarioConciliadoItem;
}

@Component({
  selector: 'app-desconciliar-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    AlertCardComponent,
    AbntPipe,
  ],
  templateUrl: './desconciliar-dialog.component.html',
  styleUrl: './desconciliar-dialog.component.css',
})
export class DesconciliarDialogComponent {
  TipoDesconciliacaoEnum = TipoDesconciliacaoEnum;
  isSalvando = false;
  tipoEmExecucao: TipoDesconciliacaoEnum | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DesconciliarDialogData,
    public dialogRef: MatDialogRef<DesconciliarDialogComponent>,
    private conciliacaoBancariaService: ConciliacaoBancariaService,
    private alertService: AlertService,
  ) {}

  get extrato(): ExtratoBancarioConciliadoItem {
    return this.data.extrato;
  }

  cancelar(): void {
    if (this.isSalvando) return;
    this.dialogRef.close();
  }

  confirmar(tipo: TipoDesconciliacaoEnum): void {
    if (this.isSalvando) return;
    this.isSalvando = true;
    this.tipoEmExecucao = tipo;
    this.dialogRef.disableClose = true;

    const request: DesconciliarRequest = { idExtratoBancario: this.extrato.idExtratoBancario, tipoDesconciliacao: tipo };
    this.conciliacaoBancariaService
      .desconciliar(request)
      .subscribe({
        next: (res) => {
          this.isSalvando = false;
          this.tipoEmExecucao = null;
          this.dialogRef.disableClose = false;
          if (res.isError) {
            this.alertService.show('Erro', res.errorDescription, AlertType.error);
            return;
          }
          this.dialogRef.close({ sucesso: true });
        },
        error: (err) => {
          this.isSalvando = false;
          this.tipoEmExecucao = null;
          this.dialogRef.disableClose = false;
          this.alertService.show('Erro', err.message, AlertType.error);
        },
      });
  }
}
